import PropTypes from 'prop-types'
import { AUMENTO_TIENDA_OFICIAL } from '../../constants/tiendaOficial.js'
import { calcularTotalItemConIva } from '../helpers/calcularPrecioTotal'
import Precios from '../reutilizables/precios/Precios'
import styles from './DetalleCobro.module.css'

const IVA_ENVIO = 1.21
const MAX_DECIMALES = 2

const DetalleCobro = ({
  cantidad,
  precio,
  porcentajeExposicion,
  exposicion,
  monedaSimbolo,
  alicuota,
  precioEnvio,
  esTiendaOficial
}) => {
  const precioUnitario = Number(precio) || 0
  const cantidadNumerica = Number(cantidad) || 1
  const alicuotaNumerica = Number(alicuota) || 0
  const porcentajeExposicionNumerico = Number(porcentajeExposicion) || 0
  const ventaTotal = calcularTotalItemConIva({
    precioUnitario,
    cantidad: cantidadNumerica,
    alicuota: alicuotaNumerica
  })
  const descuentoExposicion = (porcentajeExposicionNumerico * ventaTotal) / 100
  const descuentoTiendaOficial = esTiendaOficial ? (AUMENTO_TIENDA_OFICIAL * ventaTotal) / 100 : 0
  const envioConIva = (Number(precioEnvio) || 0) * IVA_ENVIO
  const totalCalculado = ventaTotal - descuentoExposicion - descuentoTiendaOficial + envioConIva
  const descuentoExposicionFormateado = Number(descuentoExposicion).toLocaleString('es-AR', {
    maximumFractionDigits: MAX_DECIMALES
  })
  const descuentoTiendaOficialFormateado = Number(descuentoTiendaOficial).toLocaleString('es-AR', {
    maximumFractionDigits: MAX_DECIMALES
  })

  return (
    <div className={styles.contenedor}>
      <h3 className={styles.titulo}>Detalle de Cobro</h3>
      <div className={styles.tabla}>
        <div className={`${styles.celdaDescripcion} ${styles.encabezado}`}>Descripción</div>
        <div className={`${styles.celdaImporte} ${styles.encabezado}`}>Importe</div>

        <div className={styles.celdaDescripcion}>Venta (x {cantidad})</div>
        <div className={styles.celdaImporte}>
          <Precios
            precio={precioUnitario}
            monedaSimbolo={monedaSimbolo}
            alicuota={alicuotaNumerica}
            cantidad={cantidadNumerica}
            showSinIVA={true}
          />
        </div>

        {precioEnvio > 0 && (
          <>
            <div className={styles.celdaDescripcion}>Envío</div>
            <div className={styles.celdaImporte}>
              <Precios
                precio={precioEnvio}
                monedaSimbolo={monedaSimbolo}
                alicuota={21}
                showSinIVA={true}
              />
            </div>
          </>
        )}

        <div className={styles.celdaDescripcion}>
          Exposición {exposicion} ({porcentajeExposicion}%)
        </div>
        <div className={`${styles.celdaImporte} ${styles.descuento}`}>
          <b>
            -{monedaSimbolo}
            {descuentoExposicionFormateado}
          </b>
        </div>

        {esTiendaOficial && (
          <>
            <div className={styles.celdaDescripcion}>Tienda Oficial (1%)</div>
            <div className={`${styles.celdaImporte} ${styles.descuento}`}>
              <b>
                -{monedaSimbolo}
                {descuentoTiendaOficialFormateado}
              </b>
            </div>
          </>
        )}

        <div className={`${styles.celdaDescripcion} ${styles.filaTotal}`}>Total</div>
        <div className={`${styles.celdaImporte} ${styles.filaTotal}`}>
          <Precios
            precio={totalCalculado}
            monedaSimbolo={monedaSimbolo}
            alicuota={0}
            showSinIVA={false}
          />
        </div>
      </div>
    </div>
  )
}

DetalleCobro.propTypes = {
  precio: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  cantidad: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  monedaSimbolo: PropTypes.string.isRequired,
  exposicion: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  porcentajeExposicion: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  alicuota: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  precioEnvio: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  esTiendaOficial: PropTypes.bool.isRequired
}

export default DetalleCobro
